import React, { useEffect, useState } from 'react';
import styles from './Step2.module.css';
import Step2DesktopContent from '@modules/Steps/Components/Step2/Step2DesktopContent/Step2DesktopContent';
import { useProjectStore } from '../../../../Stores/ProjectStore';
import { StepsHeader } from '@modules/Steps/Shared/Ui/Headers/StepsHeader/StepsHeader';
import { useParams } from 'react-router-dom';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { ViewItemTypesModeEnum } from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { GrandTotalStep2Buttons } from '@modules/Steps/Components/Step2/GrandTotalStep2Buttons/GrandTotalStep2Buttons';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { BOMProjectExampleData } from '@mockData/BOMProjectExampleData';
import { CustomProjectStep2UserGuide } from '@modules/Steps/UserGuideSteps/CustomProjectStep2UserGuide';
import { UserGuideKeyEnum } from '@shared/Enums/UserGuideKeyEnum';
import { useUserGuideTour } from '@shared/Hooks/useUserGuideTour';
// import Joyride from 'react-joyride';
import Step2MobileContent from '@modules/Steps/Components/Step2/Step2MobileContent/Step2MobileContent';
import GrandTotalSelectedFooter from '@shared/Widgets/GrandTotalSelectedFooter/GrandTotalSelectedFooter';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { useFragmentsStore } from '../../../../Stores/FragmentsStore';
import { CustomProjectInfoViewModel } from '@viewModels/CustomProjectInfoViewModel';
import { TemplateMainInfoSection } from '@modules/Steps/Shared/Ui/Headers/TemplateMainInfoSection/TemplateMainInfoSection';
import { UserGuideCursor } from '@shared/Ui/UserGuideCursor/UserGuideCursor';
import { JoyrideStyles } from '@styles/GlobalJoyrideStyles/JoyrideStyles';
import { MockRawGalleries } from '@mockData/MockRawGalleries';

const Step2: React.FC = () => {
    const { customProject } = useProjectStore();

    const {
        parsedFragments,
        fragmentsViewMode,
        laborItemTypes,
        toolItemTypes,
        fragmentsWithMaterialItemTypes,
    } = useFragmentsStore();

    const { viewMode, projectId } = useParams();
    const [isDesktop] = useMediaType();

    const customProjectInfoViewModel = new CustomProjectInfoViewModel();
    const fragmentsViewModel = new FragmentsViewModel();
    const shouldReload = sessionStorage.getItem('forceReload');

    // const steps = CustomProjectStep2UserGuide;
    // const tourKey = UserGuideKeyEnum.CUSTOM_PROJECT_STEP2_GUIDE;
    // const { runTour, handleJoyrideCallback, stepIndex, cursorPositions } =
    //     useUserGuideTour(
    //         tourKey,
    //         isDesktop && viewMode === StepsViewModeEnum.PROJECT,
    //         steps
    //     );

    const [step2ProjectLoading, setStep2ProjectLoading] =
        useState<boolean>(false);

    const fetchStep2Data = async () => {
        setStep2ProjectLoading(true);
        try {
            const response = await customProjectInfoViewModel.getCustomProject(
                Number(projectId)
            );
            await fragmentsViewModel.getParsedFragments(Number(projectId));
            await fragmentsViewModel.getGalleryData();
            await fragmentsViewModel.getItemTypesWithItems(
                response.data?.store_id ?? 0
            );
        } finally {
            setStep2ProjectLoading(false);
        }
    };

    useEffect(() => {
        if (viewMode === StepsViewModeEnum.PROJECT) {
            fetchStep2Data();
        } else {
            customProjectInfoViewModel.getExampleProject(BOMProjectExampleData);
            fragmentsViewModel.getExampleGalleryData(MockRawGalleries);
        }
    }, [shouldReload]);

    const fragments =
        fragmentsViewMode === ViewItemTypesModeEnum.WorkStage
            ? parsedFragments
            : fragmentsWithMaterialItemTypes;

    const grandTotal = fragmentsViewModel.getFragmentsItemTotal();
    const toolsTotal = fragmentsViewModel.getFragmentsToolItemTotal();
    const materialsTotal = fragmentsViewModel.getFragmentsMaterialsItemTotal();
    const laboursTotal = fragmentsViewModel.getFragmentsLabourItemTotal();

    if (step2ProjectLoading) {
        return <BasicLoader />;
    }

    return (
        <>
            <section className={styles.wrapper}>
                <StepsHeader title={'Step 2'} text={'Ordering process'} />

                <TemplateMainInfoSection project={customProject} />
                {isDesktop ? (
                    <Step2DesktopContent
                        fragments={fragments}
                        fragmentsViewMode={fragmentsViewMode}
                        laborItemTypes={laborItemTypes}
                        toolItemTypes={toolItemTypes}
                    />
                ) : (
                    <Step2MobileContent
                        fragments={fragments}
                        fragmentsViewMode={fragmentsViewMode}
                        laborItemTypes={laborItemTypes}
                        toolItemTypes={toolItemTypes}
                    />
                )}

                <GrandTotalSelectedFooter
                    grandTotal={grandTotal}
                    toolsTotal={toolsTotal}
                    materialsTotal={materialsTotal}
                    laboursTotal={laboursTotal}
                    runTour={false}
                >
                    <GrandTotalStep2Buttons />
                </GrandTotalSelectedFooter>
            </section>
            {/*{runTour && (*/}
            {/*    <Joyride*/}
            {/*        steps={steps}*/}
            {/*        run={runTour}*/}
            {/*        stepIndex={stepIndex}*/}
            {/*        disableScrollParentFix={true}*/}
            {/*        spotlightClicks={true}*/}
            {/*        continuous={false}*/}
            {/*        disableOverlayClose={false}*/}
            {/*        callback={handleJoyrideCallback}*/}
            {/*        showProgress={false}*/}
            {/*        showSkipButton={true}*/}
            {/*        styles={JoyrideStyles}*/}
            {/*    />*/}
            {/*)}*/}

            {/*{runTour &&*/}
            {/*    cursorPositions.length > 0 &&*/}
            {/*    cursorPositions.map((position, index) => (*/}
            {/*        <UserGuideCursor*/}
            {/*            key={index}*/}
            {/*            top={position.top}*/}
            {/*            left={position.left}*/}
            {/*        />*/}
            {/*    ))}*/}
        </>
    );
};

export default Step2;
